import React from 'react';

import {
  Grid,
} from '@mui/material';

import ThresholdInput from './ThresholdInput';
import TransactionTypeConfiguration from './TransactionTypeConfiguration';

const AmountThreshold = () => (
  <Grid size={12}>
    <Grid container spacing={3}>
      <ThresholdInput
        source="default"
        title="Upper Threshold"
        subheader="Trigger when amount is greater than this threshold. Can be combined with lower threshold to detect amounts outside a specific range. If omitted the rule will not trigger on high amounts."
        optional
      />
      <ThresholdInput
        source="lowerThreshold"
        title="Lower Threshold"
        subheader="Trigger when amount is less than this threshold. Can be combined with upper threshold to detect amounts outside a specific range. If omitted the rule will not trigger on low amounts."
        optional
      />
      <TransactionTypeConfiguration />
    </Grid>
  </Grid>

);

export default AmountThreshold;
